import { useMediaQuery } from '@mui/material';

export type Orientation = 'portrait' | 'landscape';

/**
 * Reports the device orientation using the CSS `(orientation: portrait)` media
 * query. Updates live on rotate.
 *
 * Pair with `useResponsive` when a view needs to force a specific orientation
 * on mobile (wide tables like timesheet/calendar). See `OrientationPrompt`.
 */
export function useOrientation(): Orientation {
  const isPortrait = useMediaQuery('(orientation: portrait)');
  return isPortrait ? 'portrait' : 'landscape';
}
